const addQueryParams = (url: string, params: object): string => {
    try {
        const urlObject = new URL(url);
        for (const [key, value] of Object.entries(params)) {
            urlObject.searchParams.append(key, value);
        }
        return urlObject.toString();
    } catch {
        return url;
    }
};

export default addQueryParams;
